import { render, staticRenderFns } from "./thumbold.vue?vue&type=template&id=4566ed6e&scoped=true&"
import script from "./thumbold.vue?vue&type=script&lang=js&"
export * from "./thumbold.vue?vue&type=script&lang=js&"
import style0 from "./thumbold.vue?vue&type=style&index=0&id=4566ed6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4566ed6e",
  null
  
)

export default component.exports